/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ActionIcon,
  Avatar,
  Box,
  Button,
  Group,
  Modal,
  TextInput,
  Tooltip
} from "@mantine/core";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import {
  UpdatePatientInput,
  UpdatePatientMutation,
  UpdatePatientMutationVariables
} from "../../API";
import { updatePatient } from "../../graphql/mutations";
import { IconUpload } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { getUrl, uploadData } from "aws-amplify/storage";
const client = generateClient();
type editPatientProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  setModalConfirmDeleteOpened: (value: boolean) => void;
  patient: any;
  setPatient: (value: any) => void;
  fetchPatients: () => void;
};

const EditPatientModal = (props: editPatientProps) => {
  const {
    modalOpened,
    setModalOpened,
    patient,
    setPatient,
    fetchPatients,
    setModalConfirmDeleteOpened
  } = props;
  useEffect(() => {
    if (modalOpened) {
      setImageStoragePath("");
      setIsUpdateImage(false);
      setPatientImage(patient?.s3Image);
    }
  }, [modalOpened, patient]);
  const handleEditPatient = async () => {
    try {
      const updatedPatientInput: UpdatePatientInput = {
        id: patient.id,
        name: patient.name,
        client: patient.client,
        _version: patient._version
      };
      if (isUpdateImage) {
        updatedPatientInput["image"] = imageStoragePath;
      }
      const updatedPatientVars: UpdatePatientMutationVariables = {
        input: updatedPatientInput
      };

      await client.graphql<GraphQLQuery<UpdatePatientMutation>>({
        query: updatePatient,
        variables: updatedPatientVars
      });
      fetchPatients();
    } catch (err: any) {
      console.log("error editing patient:", err);
      if (err?.data?.updatePatient != null) {
        fetchPatients();
      }
    }

    setModalOpened(false);
  };
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(false);
  const [isUpdateImage, setIsUpdateImage] = useState(false);
  const [patientImage, setPatientImage] = useState(patient?.s3Image);
  const [imageStoragePath, setImageStoragePath] = useState("");
  const handlePatientImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0] || null;
    let storagePath = "";
    let s3Image = "";
    if (file) {
      //get the file extension
      const fileExtension = "." + file.name?.replace(/ /g, "-");

      //convert file to blob
      const blob = new Blob([file], { type: file.type });
      //get the storagepath
      storagePath =
        patient.lID +
        "/" +
        patient.id +
        "/profilePicture/patientImage" +
        fileExtension;

      setLoading(true);

      const s3Put = uploadData({
        path: `public/${storagePath}`,
        data: blob,
        options: {}
      }); // can also do onProgress
      await s3Put.result;
      // Get download URL
      s3Image = (
        await getUrl({
          path: `public/${storagePath}`,
          options: { validateObjectExistence: true }
        })
      ).url.toString();
      setImageStoragePath(storagePath);
      setPatientImage(s3Image);
      setIsUpdateImage(true);
      setLoading(false);
      // Reset the file input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };
  return (
    <Modal
      opened={modalOpened}
      onClose={() => setModalOpened(false)}
      title="Edit patient"
    >
      <Box className="box-avatar" mt={0}>
        <input
          type="file"
          accept="image/png,image/jpeg"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handlePatientImageUpload}
        />
        <Avatar src={patientImage} size={80} radius={80} mx="auto" />
        <Tooltip label="Upload picture" withArrow>
          <ActionIcon
            loading={loading}
            radius="lg"
            color="#adb5bd"
            className="btn-change-avatar"
            size={"sm"}
            onClick={() => fileInputRef.current?.click()}
          >
            <IconUpload size={"16"} />
          </ActionIcon>
        </Tooltip>
      </Box>
      <TextInput
        label="Patient Name"
        placeholder="Enter patient name"
        value={patient?.name}
        onChange={(event) =>
          setPatient((oldState: any) => {
            return {
              ...oldState,
              name: event.currentTarget.value
            };
          })
        }
        required
      />
      <TextInput
        label="Client Name"
        placeholder="Enter client name"
        value={patient?.client}
        onChange={(event) =>
          setPatient((oldState: any) => {
            return {
              ...oldState,
              client: event.currentTarget.value
            };
          })
        }
        required
      />
      <Group mt="md">
        <Group mt="md">
          <Button onClick={handleEditPatient}>Save</Button>
          <Button
            color="red"
            onClick={() => {
              setModalOpened(false);
              setModalConfirmDeleteOpened(true);
            }}
          >
            Delete
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default EditPatientModal;
